// Main Scripts
// ---------------------
import customButton from './js/widgets/customButton.js';

import swiperWidget from './js/widgets/swiperWidget.js';
import cardsWidget from './js/widgets/cardsWidget.js';
import animateOnScroll from './js/animateOnScroll.js';
import seoWidget from './js/widgets/seoWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import featuredItem from './js/widgets/featuredItem.js';

import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Secondary Scripts
// ---------------------
import './js/localjs.js';

// Aos Library
import AOS from 'aos';
import 'aos/dist/aos.css';

if (window.location.pathname === '/') {
  $(document).ready(function () {
    swiperWidget();
    cardsWidget();
    animateOnScroll('#animated-tagline', '#tier-2-container', 'animate');
    animateOnScroll('.inner-container-tier-c', '.inner-container-tier-c', 'animate-abstract');
    seoWidget();
    featuredItem();
    scrollerSponsors();
  });

  $(window).load(function () {
    setTimeout(() => {
      AOS.init({
        anchorPlacement: 'bottom-bottom',
        animatedClassName: 'aos-animate',
        initClassName: 'aos-init',
      });
    }, 2000);
    videoWidget();
  });
}

$(document).ready(function () {
  customButton('donateButton', donateButtonOpts, 'donate-button', true);
  customButton('careersFooterButton', careersFooterButtonOpts, 'footer-career', true);
});
